// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dSet$dSerialized from "../Data.Set.Serialized/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dMenuConsumer from "../Restaumatic.Menu.V2.Types.MenuConsumer/index.js";
import * as Unscramble from "../Unscramble/index.js";
const eq = /* #__PURE__ */ (() => {
  const eq$1 = Data$dMap$dInternal.eqMap(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.eqMenuConsumer)(Data$dEq.eqUnit).eq;
  return x => y => {
    if (x.tag === "Nothing") { return y.tag === "Nothing"; }
    if (x.tag === "Just") {
      if (y.tag === "Just") { return eq$1(x._1)(y._1); }
      return false;
    }
    return false;
  };
})();
const EnabledMenuConsumersIsSymbol = {reflectSymbol: () => "EnabledMenuConsumers"};
const EnabledMenuConsumers = x => x;
const toFillFormTypeEnabledMenu = {fillFormDataType: v => "unknown"};
const newtypeEnabledMenuConsume = {Coercible0: () => {}};
const eqEnabledMenuConsumers = {eq: x => y => eq(x)(y)};
const genericEnabledMenuConsumers = {to: x => x, from: x => x};
const showEnabledMenuConsumers = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dSet.showSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.showMenuConsumer);
      return {
        genericShowArgs: v => [
          (() => {
            if (v.tag === "Just") { return "(Just " + $0.show(v._1) + ")"; }
            if (v.tag === "Nothing") { return "Nothing"; }
            $runtime.fail();
          })()
        ]
      };
    })())(EnabledMenuConsumersIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeEnabledMenuConsumers = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble.decodeMaybe(Unscramble.decodeSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.unscrambleDecodeMenuConsumer)(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.ordMenuConsumer));
    return x => $0.unsafeDecode(x);
  })()
};
const encodeEnabledMenuConsumers = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericEnabledMenuConsumers)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(EnabledMenuConsumersIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Data$dSet$dSerialized.encodeSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.encodeMenuConsumer);
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg(
          "PlainArg",
          (() => {
            if (v.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
            if (v.tag === "Just") { return $0.encode(v._1); }
            $runtime.fail();
          })()
        ),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeEnabledMenuConsumers = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericEnabledMenuConsumers)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(EnabledMenuConsumersIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument(/* #__PURE__ */ (() => {
      const decode2 = Foreign$dNullOrUndefined.readNullOrUndefined(Data$dSet$dSerialized.decodeSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.ordMenuConsumer)(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.decodeMenuConsumer).decode);
      return {decodeWithOptions: v => decode2};
    })()),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  EnabledMenuConsumers,
  EnabledMenuConsumersIsSymbol,
  decodeEnabledMenuConsumers,
  encodeEnabledMenuConsumers,
  eq,
  eqEnabledMenuConsumers,
  genericEnabledMenuConsumers,
  newtypeEnabledMenuConsume,
  showEnabledMenuConsumers,
  toFillFormTypeEnabledMenu,
  unscrambleDecodeEnabledMenuConsumers
};
